import { Injectable, inject } from '@angular/core';
import { BreakpointService } from './breakpoint.service';

/**
 * @deprecated Use BreakpointService. Kept so existing callers compile; both answers now follow the viewport
 * width instead of the user agent.
 */
@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  private readonly breakpoints = inject(BreakpointService);

  isMobile(): boolean {
    return this.breakpoints.isPhone();
  }

  isTablet(): boolean {
    return this.breakpoints.isTablet();
  }
}
